import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Form, Input } from 'antd';
import { FieldWrapper } from './FieldWrapper';
const { TextArea } = Input;

export const AntTextArea = ({
  name,
  label,
  description,
  placeholder,
  rows = 5,
  rules,
  ...props
}) => {
  const { control, errors } = useFormContext();

  return (
    <FieldWrapper
      label={label}
      description={description}
      error={errors[name]?.message}>
      <Form.Item className="m-0">
        <Controller
          rules={rules}
          defaultValue=""
          name={name}
          label={label}
          control={control}
          placeholder={placeholder}
          rows={rows}
          as={<TextArea />}
          {...props}
        />
      </Form.Item>
    </FieldWrapper>
  );
};
